import {defineStore} from "pinia";

export const useShareStore = defineStore("share", () => {

    // Process Data
    const process = reactive({
        isProgress: false,
        action: null,
    });

    // SnakeBar Data
    const snackBar = reactive({
        show: false,
        message: null,
        data: null
    });

    // Error Responses
    const errorResponse = reactive({
        error: false,
        errorInput: null,
        errorMessage: null
    });

    // Action Process
    const actionProcess = {
        auth: {
            signInWithEmailPassword: "signInWithEmailPassword",
            checkIsAuthorized: "checkIsAuthorized",
            logOut: "logOut",
            sendTokenMobile: "sendTokenMobile",
            verifyTokenMobile: "verifyTokenMobile"
        },
        account: {
            createDepartment: "createDepartment",
            updateDepartment: "updateDepartment",
            deleteDepartment: "deleteDepartment",
            fetchUsers: "fetchUsers",
            createUser: "createUser",
            updateUser: "updateUser",
            deleteUser: "deleteUser",
            fetchDepartments: "fetchDepartments",
        },
        form: {
            fetchForm: "fetchForm",
            updateForm: "updateForm",
            uploadFile: "uploadFile",
            createResume: "createResume"
        },
        resume: {
            fetchResumes: "fetchResumes",
            fetchResume: "fetchResume",
            createComment: "createComment",
            fetchComments: "fetchComments",
            fetchDepartments: "fetchDepartments",
            sendResume: "sendResume"
        }
    };

    function setProcess(action) {
        process.isProgress = true;
        process.action = action;
    }

    function clearProcess() {
        process.isProgress = false;
        process.action = null;
    }

    function showSnackBar(message, data = null) {
        snackBar.show = true;
        snackBar.message = message;
        snackBar.data = data;
    }

    function closeSnackBar() {
        snackBar.show = false;
        snackBar.message = null;
        snackBar.data = null;
    }

    function throwMessageErrorResponse(input) {
        if (errorResponse.error && errorResponse.errorInput === input) {
            return errorResponse.errorMessage;
        } else {
            return null;
        }
    }

    function setErrorResponse(errorMessage, errorInput = null) {
        errorResponse.error = true;
        errorResponse.errorMessage = errorMessage;
        errorResponse.errorInput = errorInput;
    }

    function clearErrorResponse() {
        errorResponse.error = false;
        errorResponse.action = null;
        errorResponse.errorMessage = null;
        errorResponse.errorInput = null;
    }

    return {
        process,
        errorResponse,
        snackBar,
        setProcess,
        actionProcess,
        clearProcess,
        setErrorResponse,
        throwMessageErrorResponse,
        clearErrorResponse,
        showSnackBar,
        closeSnackBar,
    };

});
